import gameConfig from "./game/config.js";
import preloadAssets from "./game/preload.js";
import attribute from "./game/attribute.js";
import multipleGenerator from "./game/multipleGenerator.js";

import Background from "./game/background.js";
import HeroBase from "./game/hero/base.js";
import HeroCloud from "./game/hero/cloud.js";
import HeroBasket from "./game/hero/cloud.js";

import WebFont from 'webfontloader';



window.gameData = {
  isPaused: true,
  isEnding: false,
  pointToWin: (typeof window.pointToWin != 'undefined') ? window.pointToWin : 60,
  maxPlayingTime: (typeof window.maxPlayingTime != 'undefined') ? window.maxPlayingTime * 1000 : 30000,  // about ~ 1 point per 0.5s
  playedTime: 0,
  speedMultiply: {
    slow: .5,
    normal: 1,
    fast: 3
  },
  speedCoefficient: 1,
  speed: {
    background: 1,
    dirtBack: 2.5,
    cloudBack: 2,
    tree: 2.5,
    dirtFront: 2.5,
    cloudFront: 3,
    hero: 5
  },
  isControlling: false,
  position: {
    heroInitX: 700,
    heroInitY: 400,
  },
  point: {
    bigPeach: 0,
    smallPeach: 0,
    goldenPeach: 0
  },
  pointCoefficient: {
    bigPeach: 5,
    smallPeach: 1,
    goldenPeach: 1
  },
  fruitShake: {
    start: 300,
    end: 2000,
    duration: 100,
    rotation: 1.5
  },
  spawned: 0,
  spawnSpace: 100,
  spawnRate: { // the higher the number, the lower the spawn rate; 0 means always spawn (fallback); -1 means never spawn
    smallPeach: 0,
    bigPeach: 2,
    goldenPeach: -1
  }
}

WebFont.load({ 
    "google": {
        // families: ['Roboto'],
        families: ['Roboto:wght@300,400,700,900&display=swap'],
        // timeout: 1000
  }
});

$(document).on(
  "taydu_dangkytruoc_game rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log("taydu_dangkytruoc_game rendered", uniqueId);

    
    var game = new Phaser.Game({
      ...gameConfig,
      scene: [
        sceneGame
      ]
    });
    
  }
);

class sceneGame extends Phaser.Scene {
  constructor() {
    super({
      key: "sceneGame"
    });
  }

  preload(){
    preloadAssets(this);
  }

  create() {

    this.pointCheck = {
      bigPeach: 0,
      smallPeach: 0,
      goldenPeach: 0
    }

    this.goldenPoints = gameData.point.goldenPeach;
    this.bigPoints = gameData.point.bigPeach;
    this.smallPoints = gameData.point.smallPeach;
    
    this.background = new Background({
      scene: this,
      width: gameConfig.width,
      height: gameConfig.height,
      key: "world",
      speed: window.gameData.speed.background
    });
    this.dirtBackGroup = this.add.group().addMultiple(multipleGenerator({
      scene: this,
      initX: 0,
      initY: gameConfig.height - 130,
      keyPrefix: "dirt",
      max: 5,
      total: 23,
      space: -100,
      speed: window.gameData.speed.dirtBack
    }));
    this.cloudBackGroup = this.add.group().addMultiple(multipleGenerator({
      scene: this,
      initX: 0,
      initY: gameConfig.height - 140, 
      keyPrefix: "cloud",
      max: 3,
      total: 10,
      space: -200,
      speed: window.gameData.speed.cloudBack
    }));
    this.treeGroup = this.add.group().addMultiple(multipleGenerator({
      scene: this,
      initX: 0,
      initY: gameConfig.height - 20,
      keyPrefix: "tree",
      max: 5,
      total: 23,
      space: -200,
      speed: window.gameData.speed.tree
    }));
    this.dirtFrontGroup = this.add.group().addMultiple(multipleGenerator({
      scene: this,
      initX: 0,
      initY: gameConfig.height - 160,
      keyPrefix: "dirt",
      max: 5,
      total: 23,
      space: -100,
      speed: window.gameData.speed.dirtFront,

    }));
    this.cloudFrontGroup = this.physics.add.group().addMultiple(multipleGenerator({
      scene: this,
      initX: 0, 
      initY: gameConfig.height,
      keyPrefix: "cloud",
      max: 3,
      total: 10,
      space: -200,
      speed: window.gameData.speed.cloudFront
    }));

    // this.cloudFrontGroup.

    this.fruits = this.physics.add.group();

    this.heroBase = new HeroBase({
      scene: this,
      x: 0,
      y: 400,
      key: "hero-base",
      speed: window.gameData.speed.hero
    });
    this.heroBackCloud = this.add.particles(880, 780, "hero-cloud", {
      speed: window.gameData.speed.hero,
      scale: { start: 1, end: .3 },
      gravityX: -800,
      alpha: { start: 0.5, end: 0 },
      rotate: { start: 0, end: 120 },
      blendMode: 'COLOR',

    });

    this.heroFrontCloud = new HeroCloud({
      scene: this,
      x: 40,
      y: 450,
      key: "hero-cloud",
      speed: window.gameData.speed.hero
    });
    this.heroBasket = new HeroBasket({
      scene: this,
      x: 150,
      y: 380,
      key: "hero-basket",
      speed: window.gameData.speed.hero
    });

    this.fruitInBaskets = this.add.container(0, 0).add([]);

    this.hero = this.add.container(
      gameData.position.heroInitX, 
      gameData.position.heroInitY
    ).add([
      this.heroBase,
      this.heroFrontCloud,
      this.fruitInBaskets,
      this.heroBasket
    ]);

    this.physics.world.enable(this.hero);
    this.physics.world.enable(this.heroBasket);
    this.hero.setDepth(10);
    this.hero.isMovedLeft = false;
    // this.hero.body.setCollideWorldBounds(true);
  
    this.cursors = this.input.keyboard.createCursorKeys();
    // this.heroBackCloud.startFollow(this.hero, 100, 100, true);


    this.physics.add.collider(this.fruits, this.dirtFrontGroup);
    this.physics.add.collider(this.fruits, this.heroBase);

    this.endBasket = this.add.container(gameConfig.width + 4350, gameConfig.height - 160).add([
      this.add.image(0, 0, 'end-basket-1').setOrigin(0, 1),
      this.add.image(120, 0, 'end-basket-2').setOrigin(0, 1),
    ]);
    this.endBasket.setDepth(1);
    this.endBasket.setScale(1);

    // Set interval to timing played time
    const timeCounter = setInterval(() => {
      if (gameData.isPaused) return;
      if (gameData.isEnding) return;
      gameData.playedTime += 100;
    }, 100);

    // UI

    // -- Big Peach

    this.scoreBigPeach = this.add.container(320, gameConfig.height - 80, [
      this.add.image(100, 0, 'big-peach'),
      this.add.image(130, -20, 'big-peach-leaf')
    ]);
    this.scoreBigPeach.setDepth(1);
    this.scoreBigPeach.setScale(0.7);

    this.scoreBigText = this.add.text(440, gameConfig.height - 105, 'x 0', { fontSize: 45, color: '#ffffff', fontFamily: 'Roboto', fontWeight: '900' });
    this.scoreBigText.setDepth(1);
    this.scoreBigText.setStroke('#9f4700', 10);

    // -- Small Peach

    this.scoreSmallPeach = this.add.container(550, gameConfig.height - 80, [
      this.add.image(100, 0, 'small-peach'),
      this.add.image(130, -20, 'small-peach-leaf')
    ]);
    this.scoreSmallPeach.setDepth(1);
    this.scoreSmallPeach.setScale(0.7);

    this.scoreSmallText = this.add.text(660, gameConfig.height - 105, 'x 0', { fontSize: 45, color: '#ffffff', fontFamily: 'Roboto', fontWeight: '900' });
    this.scoreSmallText.setDepth(1);
    this.scoreSmallText.setStroke('#9f4700', 10);

    // Game play UI

    // -- pause
    this.pauseButton = this.add.image(gameConfig.width - 100, 300, 'btn-pause');
    this.pauseButton.setDepth(1);
    this.pauseButton.setInteractive();
    this.pauseButton.on('pointerdown', () => {
      this.time.paused = true;
      gameData.isPaused = !gameData.isPaused;
      $(".title_wrapper").addClass("black_scene");
      this.pauseScene = this.add.container(0, 0).add([
        this.add.rectangle(0, 0, gameConfig.width, gameConfig.height, 0x000000, 0.7).setOrigin(0, 0),
        // this.add.image(gameConfig.width / 2, gameConfig.height / 2 - 100, 'text-pause'),
        this.add.image(gameConfig.width / 2, gameConfig.height / 2 + 50, 'btn-resume').setInteractive().on('pointerdown', () => {
          gameData.isPaused = false;
          this.time.paused = false;
          $(".title_wrapper").removeClass("black_scene");
          this.pauseScene.destroy();
        }
        ).on('pointerover', () => {
          this.pauseScene.list[1].setScale(1.1);        
        }
        ).on('pointerout', () => {
          this.pauseScene.list[1].setScale(1);
        }
        )
      ]);
      this.pauseScene.setDepth(100);
      
    });

    // -- moving fast
    this.fastButton = this.add.image(gameConfig.width - 100, gameConfig.height - 100, 'btn-fast');
    this.fastButton.setDepth(1);
    this.fastButton.setInteractive();
    this.fastButton.on('pointerdown', () => {
      gameData.speedCoefficient = gameData.speedMultiply.fast;
      gameData.isControlling = true;
    });
    this.fastButton.on('pointerup', () => {
      gameData.speedCoefficient = gameData.speedMultiply.normal;
      gameData.isControlling = false;
    });



    // -- moving slow
    this.slowButton = this.add.image(gameConfig.width - 230, gameConfig.height - 100, 'btn-slow');
    this.slowButton.setDepth(1);
    this.slowButton.setInteractive();
    this.slowButton.on('pointerdown', () => {
      gameData.speedCoefficient = gameData.speedMultiply.slow;
      gameData.isControlling = true;
    });
    this.slowButton.on('pointerup', () => {
      gameData.speedCoefficient = gameData.speedMultiply.normal;
      gameData.isControlling = false;
    });


    // -- Start scene

    this.startScene = this.add.container(0, 0).add([
      this.add.rectangle(0, 0, gameConfig.width, gameConfig.height, 0x000000, 0.7).setOrigin(0, 0),
      this.add.image(gameConfig.width / 2, gameConfig.height / 2 - 100, 'text-start'),
      this.add.image(gameConfig.width / 2, gameConfig.height / 2 + 50, 'btn-start').setInteractive().on('pointerdown', () => {
        gameData.isPaused = false;
        this.startScene.destroy();
        $(".title_wrapper").removeClass("black_scene");
        // -- timing to end
        this.time.addEvent({
          delay: gameData.maxPlayingTime,
          paused: gameData.isPaused, 
          callback: () => {
            gameData.isEnding = true;
            // stop scene            
          }
        });
      }).on('pointerover', () => {
        this.startScene.list[2].setScale(1.1);        
      }).on('pointerout', () => {
        this.startScene.list[2].setScale(1);
      })
    ]);
    this.startScene.setDepth(100);


    // -- End scene    
    this.endScene = this.add.container(0, 0).add([
      this.add.rectangle(0, 0, gameConfig.width, gameConfig.height, 0x000000, 0.7).setOrigin(0, 0),
      this.add.image(gameConfig.width / 2, gameConfig.height / 2 - 150, 'text-end'),
      // ---- Stats
        

      this.add.text(gameConfig.width / 2 - 310, gameConfig.height / 2 - 70, 'Hái được ', { fontSize: 45, color: '#c1b497', fontFamily: 'Tahoma', fontWeight: '900', fontStyle: 'italic' }),
      
      this.add.container(gameConfig.width / 2 - 50, gameConfig.height / 2 - 45, [
        this.add.image(0, 0, 'big-peach'),
        this.add.image(30, -20, 'big-peach-leaf')
      ]).setScale(0.7),
      this.add.text(gameConfig.width / 2 + 10, gameConfig.height / 2 - 70, 'x ' + this.bigPoints + ' ', { fontSize: 45, color: '#c1b497', fontFamily: 'Roboto', fontWeight: '900', fontStyle: 'italic' }),
      
      this.add.container(gameConfig.width / 2 + 190, gameConfig.height / 2 - 45, [
        this.add.image(0, 0, 'small-peach'),
        this.add.image(25, -12, 'small-peach-leaf')
      ]).setScale(0.6),
      this.add.text(gameConfig.width / 2 + 240, gameConfig.height / 2 - 70, 'x ' + this.smallPoints + ' ', { fontSize: 45, color: '#c1b497', fontFamily: 'Roboto', fontWeight: '900',  fontStyle: 'italic' }),
      

      this.add.text(gameConfig.width / 2 - 280, gameConfig.height / 2 + 20, 'Tổng điểm ', { fontSize: 45, color: '#c1b497', fontFamily: 'Tahoma', fontWeight: '900', fontStyle: 'italic' }),
      this.add.text(gameConfig.width / 2 - 30, gameConfig.height / 2 + 10, `${this.bigPoints * gameData.pointCoefficient.bigPeach + this.smallPoints  * gameData.pointCoefficient.smallPeach} `, { fontSize: 68, color: '#fba734', fontFamily: 'Roboto', fontWeight: '1200', fontStyle: 'italic' }),


      this.add.image(gameConfig.width / 2 - 130, gameConfig.height / 2 + 150, 'btn-restart').setInteractive().on('pointerdown', () => {
        // gameData.isPaused = false;
        this.scene.restart();
        // $(".title_wrapper").removeClass("black_scene");
        $(".title_wrapper").addClass("black_scene");
        this.endScene.setDepth(-1);
        gameData.point.bigPeach = 0;
        gameData.point.smallPeach = 0;
        gameData.point.goldenPeach = 0;
        gameData.isPaused = true;
        gameData.isEnding = false;
        gameData.spawned = 0;
        gameData.playedTime = 0;

        // end timeCounter
        clearInterval(timeCounter);

        this.fruits.clear(true, true);
      }).on('pointerover', () => {
        this.endScene.list[9].setScale(1.1);        
      }).on('pointerout', () => {
        this.endScene.list[9].setScale(1);
      }),
      this.add.image(gameConfig.width / 2 + 130, gameConfig.height / 2 + 150, (this.bigPoints  * gameData.pointCoefficient.bigPeach + this.smallPoints * gameData.pointCoefficient.smallPeach > gameData.pointToWin) ? 'btn-finish' : 'btn-finish-off').setInteractive().on('pointerdown', () => {
        if (this.bigPoints  * gameData.pointCoefficient.bigPeach + this.smallPoints * gameData.pointCoefficient.smallPeach > gameData.pointToWin) {
          
          console.log(gameData.point);

          if (typeof window.handleGameFinish === 'function') {
            window.handleGameFinish(gameData.point);
          } else {
            console.error('handleGameFinish is not a function');
          }
          
        } 



      }).on('pointerover', () => {
        this.endScene.list[10].setScale(1.1) 
      }).on('pointerout', () => {
        this.endScene.list[10].setScale(1); 
      })


    ]);
    this.endScene.setAlpha(0);
    this.endScene.setDepth(-100);

    // Process

    this.process = this.add.container(800, gameConfig.height - 70).add([
      this.add.image(0, 0, 'process').setOrigin(0, 0),
      this.add.image(0, 0, 'process-act').setOrigin(0, 0).setCrop(0, 0, 0, 18),
      this.add.image(-20, -70, 'process-icon').setOrigin(0, 0)
    ]);
    this.process.setDepth(1);
    this.process.setScale(1);



  }
  update() {
    
    const tweens = this.tweens;
    const physics = this.physics;
    const heroBasket = this.heroBasket;
    const scene = this;
    const hero = this.hero;
    const fruitInBaskets = this.fruitInBaskets;
    const fruits = this.fruits;
    const heroBackCloud = this.heroBackCloud;
    const endBasket = this.endBasket;
    const endScene = this.endScene;
    const timer = this.time;

    const pointCheck = this.pointCheck;

    // Check points are increased abnormally
    const isPointAbnormal = (acceptableDiff = 10) => {
      if (gameData.point.bigPeach - pointCheck.bigPeach >= acceptableDiff / gameData.pointCoefficient.bigPeach) return true;
      if (gameData.point.smallPeach - pointCheck.smallPeach >= acceptableDiff / gameData.pointCoefficient.bigPeach) return true;
      if (gameData.point.goldenPeach - pointCheck.goldenPeach >= acceptableDiff / gameData.pointCoefficient.bigPeach) return true;
      return false;
    }

    if (isPointAbnormal()) {
      

      this.heroBase.flipX = true;
      this.heroFrontCloud.flipX = true;
      this.heroBase.x = 110;
      this.heroBasket.x = 70;
      this.fruitInBaskets.flipX = true;
      this.fruitInBaskets.x = -60;

      this.hero.x -= gameData.speed.hero * 1.05;
      this.heroBasket.setDepth(-1);
      this.heroFrontCloud.setDepth(-1);
      this.fruitInBaskets.setDepth(-1);
      this.heroBackCloud.gravityX = -1000;


    }


    // Update score
    this.scoreBigText.setText('x ' + gameData.point.bigPeach);
    this.scoreSmallText.setText('x ' + gameData.point.smallPeach);
    
    // Update process
    // console.log(timer);
    this.process.list[1].setCrop(0, 0, 877 * gameData.playedTime / gameData.maxPlayingTime, 18);
    this.process.list[2].x = 877 * gameData.playedTime / gameData.maxPlayingTime - 20;
    
    // on hold arrow key
    // gameData.speedCoefficient = gameData.speedMultiply.normal;

    // is click on fast button || left arrow key

    if (this.cursors.left.isDown) {
      gameData.speedCoefficient = gameData.speedMultiply.slow;
      heroBackCloud.gravityX = -600;
      // this.heroBase.flipX = true;
    } else if (this.cursors.right.isDown) {
      gameData.speedCoefficient = gameData.speedMultiply.fast;
      heroBackCloud.gravityX = -1200;
      // this.heroBase.flipX = false;
    } else {

      gameData.speedCoefficient = gameData.speedMultiply.normal; 
      heroBackCloud.gravityX = -800;
    }



    // Ending
    if (gameData.isEnding) {
      gameData.speedCoefficient = 10;
      
      if (this.hero.x > 200  && !this.hero.isMovedLeft) {
        this.hero.x -= gameData.speed.hero * 1.05;
        // Move cloudFrontGroup to hero
        heroBackCloud.x = this.hero.x + 180;
        heroBackCloud.gravityX = -1000;
      } else if (this.hero.x <= 200) {
        this.hero.isMovedLeft = true;
      }

      if (this.hero.x < gameConfig.width - 800 && this.hero.isMovedLeft) {
        this.hero.x += gameData.speed.hero * 1.05;
        endBasket.x -= gameData.speed.tree * gameData.speedCoefficient;
        // Move cloudFrontGroup to hero
        heroBackCloud.x = this.hero.x + 180;
        heroBackCloud.gravityX = -3000;
      }  

    }

    if (this.hero.x >= gameConfig.width - 800) {
      gameData.isPaused = true;
      this.heroBackCloud.gravityX = 0;

      // wait 1s
      setTimeout(() => {
        if (
          !endScene.list[4] ||
          !endScene.list[6] ||
          !endScene.list[8]
        ) return;
        endScene.list[4].setText('x ' + gameData.point.bigPeach + ' ');
        endScene.list[6].setText('x ' + gameData.point.smallPeach + ' ');
        endScene.list[8].setText(`${gameData.point.bigPeach * gameData.pointCoefficient.bigPeach + gameData.point.smallPeach * gameData.pointCoefficient.smallPeach} `);
        endScene.list[10].setTexture((gameData.point.bigPeach * gameData.pointCoefficient.bigPeach + gameData.point.smallPeach * gameData.pointCoefficient.smallPeach > gameData.pointToWin) ? 'btn-finish' : 'btn-finish-off');
        $(".title_wrapper").addClass("black_scene");
        endScene.setDepth(100);
        endScene.setAlpha(1);
      }, 1000);
    }


    this.background.update(gameData.isPaused, gameData.speedCoefficient);
    this.dirtBackGroup.children.iterate(function (child) {child.update(gameData.isPaused, gameData.speedCoefficient);});
    this.cloudBackGroup.children.iterate(function (child) {child.update(gameData.isPaused, gameData.speedCoefficient);});
    this.treeGroup.children.iterate(function (child) {child.update(gameData.isPaused, gameData.speedCoefficient);});
    this.dirtFrontGroup.children.iterate(function (child) {child.update(gameData.isPaused, gameData.speedCoefficient);});
    this.cloudFrontGroup.children.iterate(function (child) {child.update(gameData.isPaused, gameData.speedCoefficient);});
    // this.hero.children.iterate(function (child) {child.update();});

    // Spawn -- Peach
        
    // console.log(this.fruits.getLength());
    
    if (this.fruits.getLength() < 20 && !gameData.isPaused) {

      const bigPeachSpawnRateRandom = Phaser.Math.Between(0, gameData.spawnRate.bigPeach);
      const smallPeachSpawnRateRandom = Phaser.Math.Between(0, gameData.spawnRate.smallPeach);
      const goldenPeachSpawnRateRandom = Phaser.Math.Between(0, gameData.spawnRate.goldenPeach);

      if (goldenPeachSpawnRateRandom === 0 && gameData.spawnRate.goldenPeach !== -1) {
        var fruit = scene.add.container(
          0 + gameData.spawned * gameData.spawnSpace + Phaser.Math.Between(-80, 80),
          100 + Phaser.Math.Between(100, 300)
        ).add([
          this.add.image(0, 0, 'golden-peach'),
          this.add.image(30, -20, 'golden-peach-leaf')
        ]);
        fruit.scale = 0.7;
        fruit.fruitType = 'golden-peach';
      }  else if (bigPeachSpawnRateRandom === 0 && gameData.spawnRate.bigPeach !== -1) {
        var fruit = scene.add.container(
          0 + gameData.spawned * gameData.spawnSpace + Phaser.Math.Between(-80, 80),
          100 + Phaser.Math.Between(100, 300)
        ).add([
          this.add.image(0, 0, 'big-peach'),
          this.add.image(30, -20, 'big-peach-leaf')
        ]);
        fruit.scale = 0.7;
        fruit.fruitType = 'big-peach';
      } else if (smallPeachSpawnRateRandom === 0 && gameData.spawnRate.smallPeach !== -1) {
        var fruit = scene.add.container(
          0 + gameData.spawned * gameData.spawnSpace + Phaser.Math.Between(-80, 80),
          100 + Phaser.Math.Between(100, 300)
        ).add([
          this.add.image(0, 0, 'small-peach'),
          this.add.image(25, -12, 'small-peach-leaf')
        ]);
        fruit.scale = 0.6;
        fruit.fruitType = 'small-peach';
      }

      fruit.shaked = 0;
      fruit.dropSpeed = (fruit.dropSpeed) ? fruit.dropSpeed : Phaser.Math.Between(1, 5);
      fruit.positionToShake = (fruit.positionToShake) ? fruit.positionToShake : Phaser.Math.Between(gameData.fruitShake.start, gameData.fruitShake.end);
      fruit.shakeDuration = (fruit.shakeDuration) ? fruit.shakeDuration : gameData.fruitShake.duration;
      fruit.shakeRotation = (fruit.shakeRotation) ? fruit.shakeRotation : gameData.fruitShake.rotation;
      fruit.fruitId = (fruit.fruitId) ? fruit.fruitId : (new Date()).getTime().toString();
      // this.physics.world.enable(fruit);
      this.fruits.add(fruit);
      gameData.spawned += 1;

    
    }

    if (this.fruits.getLength() > 0 ) {


      // console.log(positionToShake);

      this.fruits.getChildren().forEach(function (fruit) {
        // fruit.setBounceY(Phaser.Math.FloatBetween(0.4, 0.8));

        fruit.x -= gameData.isPaused ? 0 :  gameData.speed.tree * gameData.speedCoefficient;
        if (fruit.x < fruit.positionToShake && fruit.shaked < 5) {
            // fruit.shaked++;
            tweens.add({
              targets: fruit,
              duration: fruit.shakeDuration,
              rotation: fruit.shakeRotation,
              yoyo: false,
              repeat: 1,
              ease: 'Sine.linear',
            });

            // remove tween

            if (fruit.y < gameConfig.height - 190) {
              fruit.y += gameData.isPaused ? 0 : fruit.dropSpeed;
              fruit.setDepth(0);
            }
        }

      });

      this.fruits.getChildren().forEach(function (fruit) {
          if (fruit.x < -fruit.width - 40) {
              fruit.destroy();
              fruits.getChildren().map((childFruit) => {
                if (childFruit.fruitId === fruit.fruitId) {
                  fruit.list.map((child) => {
                    child.destroy();
                  });
                  fruits.remove(childFruit);
                }
              });
              gameData.spawned -= 1;
          }

          if (fruit.y >= gameConfig.height - 190) {


              // fruit.destroy();
              // fruits.getChildren().map((childFruit) => {
              //   if (childFruit.fruitId === fruit.fruitId) {
              //     fruits.remove(childFruit);
              //   }
              // });
              // gameData.spawned -= 1;
              // Tween bounce

              // Change texture 
              if (fruit.fruitType === 'big-peach' && !fruit.isFalled) {
                fruit.list = [
                  scene.add.image(20, 40, 'big-peach-fall-right').setRotation(-80),
                  scene.add.image(10, -10, 'big-peach-fall-left').setRotation(80),
                  scene.add.image(26, -80, 'big-peach-leaf').setRotation(120)
                ]
              } else if (fruit.fruitType === 'small-peach' && !fruit.isFalled) {
                fruit.list = [
                  scene.add.image(20, 40, 'small-peach-fall-right').setRotation(-80),
                  scene.add.image(10, -10, 'small-peach-fall-left').setRotation(80),
                  scene.add.image(26, -80, 'small-peach-leaf').setRotation(120)
                ]
              } else if (fruit.fruitType === 'golden-peach' && !fruit.isFalled) {
                fruit.list = [
                  scene.add.image(20, 40, 'golden-peach-fall-right').setRotation(-80),
                  scene.add.image(10, -10, 'golden-peach-fall-left').setRotation(80),
                  scene.add.image(26, -80, 'golden-peach-leaf').setRotation(120)
                ]
              }

              fruit.isFalled = true;
              
          }

          physics.add.overlap(heroBasket, fruit, function (basket, fruit) {
            // console.log(fruit)
            fruit.destroy();
            fruits.getChildren().map((childFruit) => {
              if (childFruit.fruitId === fruit.fruitId) {
                fruit.list.map((child) => {
                  child.destroy();
                });
                fruits.remove(childFruit);
              }
            });
            gameData.spawned -= 1;
            if (fruit.fruitType === 'big-peach') {
              pointCheck.bigPeach += 1;
              gameData.point.bigPeach += 1;
            } else if (fruit.fruitType === 'small-peach') {
              pointCheck.smallPeach += 1;
              gameData.point.smallPeach += 1;
            } else if (fruit.fruitType === 'golden-peach') {
              pointCheck.goldenPeach += 1;
              gameData.point.goldenPeach += 1;
            }

            const totalPoints = gameData.point.bigPeach + gameData.point.smallPeach + gameData.point.goldenPeach;

            var fruitBasketX = 210 + Phaser.Math.Between(-30, 30);
            var fruitBasketY = 340 - 2 * Phaser.Math.Between(0, totalPoints);

            // prevent fruit in basket is out of the basket
            while (fruitBasketY < 200) {
              fruitBasketY = 340 - 2 * Phaser.Math.Between(0, totalPoints);
            }

            // add fruit to heroBasket
            var fruitInBasket = scene.add.container(fruitBasketX, fruitBasketY, [
              scene.add.image(0, 0, fruit.fruitType),
              scene.add.image(30, -20, fruit.fruitType + '-leaf')
            ])
            fruitInBasket.scale = 0.5;
            fruitInBasket.setDepth(totalPoints);
            fruitInBasket.setScrollFactor(0);
            // fruitInBasket.setScale();
            fruitInBasket.setAngle(Phaser.Math.Between(-30, 30));
            
            fruitInBaskets.add([
              fruitInBasket
            ]);


            // console.log(gameData.point);
          }, null, this);

          // bounce fruit when overlap with hero


      });
    }


  }
  render() {
    // this.background.render();
  }
}